<template>
    <QuillEditor ref="quillRef" theme="snow" v-model:content="content" contentType="html" class="large-editor"
        @text-change="handleMaxLength" :toolbar="customToolbar" />
</template>

<script>
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default {
    components: {
        QuillEditor,
    },
    props: {
        modelValue: String,
        maxLength: {
            type: Number,
            default: 3000,
        },
    },
    data() {
        return {
            content: this.modelValue,
            customToolbar: [
                [{ header: [1, 2, 3, false] }], // Heading options
                ["bold", "italic", "underline"], // Text styling
                [{ color: [] }, { background: [] }], // Pilihan warna teks & background
                [{ list: "ordered" }, { list: "bullet" }], // List format
                ["link"], // Insert link
                ["clean"], // Clear formatting
            ],
        };
    },
    watch: {
        modelValue(newVal) {
            this.content = newVal;
        },
        content(newVal) {
            this.$emit("update:modelValue", newVal);
        },
    },
    methods: {
        handleMaxLength() {
            const quill = this.$refs.quillRef?.getQuill();
            if (!quill) return;

            const text = quill.getLength();
            if (text > this.maxLength) {
                quill.deleteText(this.maxLength, text);
            }
        },
    },
};
</script>
